import { Grid, Text } from '@mantine/core';
import { useParams } from 'wouter';
import { useAgent } from '@/models/agents';
import { AgentDetailsForm } from './AgentDetailsForm';
import { AgentServices } from './AgentServices';

export default function AgentDetails() {
  const { id } = useParams();
  const { data: agent } = useAgent(Number(id));

  if (!agent) return <Text>Agent not found</Text>;

  return (
    <>
      <Grid.Col span={4} p={'xs'}>
        <AgentDetailsForm agent={agent} />
      </Grid.Col>
      <Grid.Col span={4} p={'xs'}>
        <AgentServices agent={agent} />
      </Grid.Col>
    </>
  );
}
